import axios from "axios";

export const GET_ALL = "axa";


export let getAll = function (status) {
  return axios.get(`${GET_ALL}`);
}